import React, { useEffect, useState, useRef } from "react";
import sal from "sal.js";
import Link from "next/link";
import { useRouter } from 'next/router';
import { createConversationApi, uploadDocumentApi, getCareerDocumentsApi, createForumPostApi, createForumPostCommentApi } from "@/services/userApi";
import { toast } from 'react-toastify';
import { useUserContext } from "@/context/UserContext";
import { updateApplicationApi } from "@/services/userApi";

const Modal = ({ refreshConversations, refreshPosts, refreshComments, applicationToEdit, fetchApplications }) => {
  console.log("applicationToEdit", applicationToEdit);
  const router = useRouter();

  console.log("Modal component rendered. Refresh Conversations:", refreshConversations);

  const [selectedValues, setSelectedValues] = useState([]);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [careerPath, setCareerPath] = useState('');
  const [solicitorPath, setSolicitorPath] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isCreatingLegalConversation, setIsCreatingLegalConversation] = useState(false);
  const [isCreatingCareerConversation, setIsCreatingCareerConversation] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [postTitle, setPostTitle] = useState('');
  const [postContent, setPostContent] = useState('');
  const [isCreatingPost, setIsCreatingPost] = useState(false);
  const [replyContent, setReplyContent] = useState('');
  const [isCreatingReply, setIsCreatingReply] = useState(false);
  // const [currentCategoryId, setCurrentCategoryId] = useState(null);
  const dropdownRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState('');
  const { userLoggedIn, userInfo } = useUserContext();
  const [editFormData, setEditFormData] = useState({
    id: (applicationToEdit && applicationToEdit.id) || null,
    opportunity_id: (applicationToEdit && applicationToEdit.opportunity.id) || null,
    user_id: (applicationToEdit && applicationToEdit.user_id) || null,
    institution_name: (applicationToEdit && applicationToEdit.opportunity.institution_name) || '',
    institution_type: (applicationToEdit && applicationToEdit.opportunity.institution_type) || '',
    opportunity_name: (applicationToEdit && applicationToEdit.opportunity.name) || '',
    opportunity_type: (applicationToEdit && applicationToEdit.opportunity.type) || '',
    deadline: (applicationToEdit && applicationToEdit.opportunity.deadline) || '',
    has_applied: (applicationToEdit && applicationToEdit.has_applied) || false,
    applied_date: (applicationToEdit && applicationToEdit.applied_date) || '',
    has_interview: (applicationToEdit && applicationToEdit.has_interview) || false,
    interview_date: (applicationToEdit && applicationToEdit.interview_date) || '',
    has_offer: (applicationToEdit && applicationToEdit.has_offer) || false,
    offer_date: (applicationToEdit && applicationToEdit.offer_date) || '',
    notes: (applicationToEdit && applicationToEdit.notes) || ''
  });
  console.log("editFormData", editFormData);

  useEffect(() => {
    sal();
  }, []);

  useEffect(() => {
    if (applicationToEdit) {
      setEditFormData({
        id: applicationToEdit.id || null,
        opportunity_id: applicationToEdit.opportunity_id || null,
        user_id: applicationToEdit.user_id || null,
        institution_name: applicationToEdit.opportunity.institution_name || '',
        institution_type: applicationToEdit.opportunity.institution_type || '',
        opportunity_name: applicationToEdit.opportunity.name || '',
        opportunity_type: applicationToEdit.opportunity.type || '',
        deadline: applicationToEdit.opportunity.deadline || '',
        has_applied: applicationToEdit.has_applied || false,
        applied_date: applicationToEdit.applied_date || '',
        has_interview: applicationToEdit.has_interview || false,
        interview_date: applicationToEdit.interview_date || '',
        has_offer: applicationToEdit.has_offer || false,
        offer_date: applicationToEdit.offer_date || '',
        notes: applicationToEdit.notes || ''
      });
    }
  }, [applicationToEdit]);

  const career_types = [
    "career_law_firm_tc",
    "career_law_firm_vacation_scheme",
    "career_law_firm_apprenticeship",
    "career_chambers_pupillage",
    "career_chambers_mini_pupillage"
  ];

  useEffect(() => {
    const fetchCareerDocuments = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const careerDocs = await getCareerDocumentsApi();
        if (careerDocs.error) {
          setError(careerDocs.error);
        } else {
          let selectedCareerType = '';
          if (careerPath === 'Solicitor') {
            if (solicitorPath === 'TrainingContract') {
              selectedCareerType = 'career_law_firm_tc';
            } else if (solicitorPath === 'Apprenticeship') {
              selectedCareerType = 'career_law_firm_apprenticeship';
            }
          } else if (careerPath === 'Barrister') {
            selectedCareerType = 'career_chambers_pupillage';
          }

          if (selectedCareerType && careerDocs[selectedCareerType]) {
            const docs = careerDocs[selectedCareerType];
            setOptions(docs.map(doc => ({
              value: doc.id,
              label: doc.document_title.replace(".pdf", "")
            })));
          } else {
            setOptions([]);
          }
        }
      } catch (err) {
        setError("An error occurred while fetching career documents.");
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    if (careerPath) {
      fetchCareerDocuments();
    }
  }, [careerPath, solicitorPath]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleChange = (event) => {
    const selectedOptions = Array.from(
      event.target.selectedOptions,
      (option) => option.value
    );
    setSelectedValues(selectedOptions);
  };

  const handleFileUpload = async (event) => {
    if (!userLoggedIn) {
      switchToModal('newChatModal', 'notLoggedInModal');  
      return;
    }

    if (!userInfo?.is_premium_member) {
      // Close any existing modals
      switchToModal('newChatModal', 'notProModal');
      return;
    }

    const files = Array.from(event.target.files);
    if (files.length > 5) {
      alert("You can only upload a maximum of 5 PDFs.");
      return;
    }

    for (const file of files) {
      if (file.type !== "application/pdf") {
        alert("Only PDF files are allowed.");
        return;
      }

      try {
        const response = await uploadDocumentApi(file);
        setUploadedDocuments(prev => [...prev, {
          document_title: response.document_title,
          document_id: response.id
        }]);
      } catch (error) {
        console.error("Error uploading document:", error);
        alert("Failed to upload document. Please try again.");
      }
    }
  };

  const handleCreateLegalResearchConversation = async () => {
    if (!userLoggedIn) {
      switchToModal('newChatModal', 'notLoggedInModal');
      return;
    }

    if (!userInfo?.is_premium_member) {
      switchToModal('newChatModal', 'notProModal');
      return;
    }

    if (uploadedDocuments.length === 0) {
      alert("Please upload at least one document before creating a conversation.");
      return;
    }

    setIsCreatingLegalConversation(true);
    try {
      // Extract just the document_id values from the uploadedDocuments array
      const documentIds = uploadedDocuments.map(doc => doc.document_id);
      
      const response = await createConversationApi(documentIds, "research")
      console.log("Conversation created:", response);
      await refreshConversations();
      await new Promise(resolve => setTimeout(resolve, 3000));
      
      // Reset the uploaded documents state
      setUploadedDocuments([]);
      
      // Reset the file input
      const fileInput = document.getElementById('file-upload');
      if (fileInput) {
        fileInput.value = '';
      }
      
      closeModal("newChatModal");
    } catch (error) {
      console.error("Error creating conversation:", error);
      alert("Failed to create conversation. Please try again.");
    } finally {
      setIsCreatingLegalConversation(false);
    }
  };

  const handleCreateCareerResearchConversation = async () => {
    if (!userLoggedIn) {
      switchToModal('newCareerModal', 'notLoggedInModal');
      
      return;
    }

    if (!userInfo?.is_premium_member) {
      switchToModal('newCareerModal', 'notProModal');
    
      return;
    }

    console.log("Selected option:", selectedOption)
    const document_ids = [selectedOption];

    setIsCreatingCareerConversation(true);
    try {
      console.log("Creating conversation...");
      const response = await createConversationApi(document_ids, "career");
      console.log("Conversation created:", response);
      
      console.log("Fetching conversations...");
      await refreshConversations();
      console.log("Conversations fetched successfully");
      
      // Force close the modal
      closeModal("newCareerModal");
    } catch (error) {
      console.error("Error in handleCreateCareerResearchConversation:", error);
      alert("Failed to create conversation. Please try again.");
    } finally {
      setIsCreatingCareerConversation(false);
    }
  };

  const handleCreateForumPost = async () => {
    if (!postTitle.trim() || !postContent.trim()) {
      toast.error('Please fill in both title and content.');
      return;
    }

    setIsCreatingPost(true);
    try {
      const currentCategoryId = router.query.categoryId;
      const response = await createForumPostApi(currentCategoryId, postTitle, postContent);
      console.log("Post created:", response);
      toast.success('Post created successfully!');
      setPostTitle('');
      setPostContent('');
      closeModal();
      
      // Call the refreshPosts callback
      if (refreshPosts) {
        refreshPosts();
      }

    } catch (error) {
      console.error("Error creating post:", error);
      toast.error('Failed to create post. Please try again.');
    } finally {
      setIsCreatingPost(false);
    }
  };

  const handleAddReply = async () => {
    if (!replyContent.trim()) {
      toast.error('Please enter a reply.');
      return;
    }

    setIsCreatingReply(true);
    try {
      const currentPostId = router.query.postId;
      const response = await createForumPostCommentApi(currentPostId, replyContent);
      console.log("Reply added:", response);
      console.log("Reply added:", replyContent);
      toast.success('Reply added successfully!');
      setReplyContent('');
      closeModal('addReplyModal');
      // Call the refreshComments callback
      if (refreshComments) {
        refreshComments();
      }
    } catch (error) {
      console.error("Error adding reply:", error);
      toast.error('Failed to add reply. Please try again.');
    } finally {
      setIsCreatingReply(false);
    }
  };

  // Add this function to reset all career-related fields
  const resetCareerFields = () => {
    setCareerPath('');
    setSolicitorPath('');
    setSelectedOption('');
    setSearchTerm('');
    setIsDropdownOpen(false);
  };

  const resetNewDocumentResearchFields = () => {
    setUploadedDocuments([]);
    const fileInput = document.getElementById('file-upload');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const resetEditApplicationFields = () => {
    setEditFormData({
      has_applied: false,
      applied_date: '',
      has_interview: false,
      interview_date: '',
      has_offer: false,
      offer_date: '',
      notes: ''
    });
  };

  // Add useEffect to listen for modal close events
  useEffect(() => {
    const careerModal = document.getElementById('newCareerModal');
    if (careerModal) {
      careerModal.addEventListener('hidden.bs.modal', resetCareerFields);
      return () => {
        careerModal.removeEventListener('hidden.bs.modal', resetCareerFields);
      };
    }
  }, []);

  // Add this function at the beginning of the Modal component
  const openModal = () => {
    const modal = document.getElementById('newCareerModal');
    if (modal) {
      modal.style.display = 'block';
      modal.classList.add('show');
      document.body.classList.add('modal-open');
      
      // Add backdrop
      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      document.body.appendChild(backdrop);
    }
  };

  // Update the closeModal function
  const closeModal = (modalTitle) => {
    const modal = document.getElementById(modalTitle);
    if (modal) {
      // First remove classes
      modal.classList.remove('show');
      modal.style.display = 'none';
      document.body.classList.remove('modal-open');
      
      // Remove backdrop
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      
      // Reset fields after modal is fully closed
      setTimeout(() => {
        resetCareerFields();
      }, 100);
    }
  };

  // Add this function to filter options based on search term
  const filteredOptions = options.filter(option => 
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const showModal = (modalId) => {
    const modal = document.getElementById(modalId);
    modal.style.display = 'block';
    modal.classList.add('show');
    document.body.classList.add('modal-open');
    
    const backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop fade show';
    document.body.appendChild(backdrop);
  };

  const switchToModal = (currentModalType, newModalId) => {
    closeModal(currentModalType);
    
    showModal(newModalId);
  };

  // Add this function near the top of the component with other handlers
  const handleNavigate = (modalId, path) => {
    closeModal(modalId);
    router.push(path);
  };

  const handleEditApplication = async () => {
    try {
      await updateApplicationApi(editFormData);

      toast.success('Application updated successfully!');
      closeModal('editApplicationModal');
      setEditFormData({
        has_applied: false,
        applied_date: '',
        has_interview: false,
        interview_date: '',
        has_offer: false,
        offer_date: '',
        notes: ''
      });
      fetchApplications();
    } catch (error) {
      toast.error('Failed to update application:' + error);
    }
  };

  return (
    <>
      {/* ==== New Chat Section Modal ==== */}
      <div
        id="newChatModal"
        className="modal rbt-modal-box copy-modal fade"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content wrapper top-flashlight light-xl">
            <h5 className="title mb-4">Upload Documents</h5>
            <div className="file-upload-section mt--20">
              <div className="upload-area">
                <input
                  type="file"
                  accept=".pdf"
                  multiple
                  onChange={handleFileUpload}
                  id="file-upload"
                  className="file-input"
                />
              </div>
              <p className="smt-2">Upload up to 5 PDF files</p>
            </div>
            {uploadedDocuments.length > 0 && (
              <div className="uploaded-files mt-4">
                <h6>Uploaded Documents:</h6>
                <ul className="list-group">
                  {uploadedDocuments.map((document,  index) => (
                    <li key={document.document_id} className="list-group-item d-flex justify-content-between align-items-center">
                      <span>Document {index + 1}</span>
                      <span className="badge bg-primary rounded-pill">{document.document_title}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="create-conversation-section mt--20">
              <button
                className="btn-default btn-small"
                onClick={handleCreateLegalResearchConversation}
                disabled={isCreatingLegalConversation}
              >
                {isCreatingLegalConversation ? (
                  <span>Creating Conversation...</span>
                ) : (
                  <span>Create Conversation</span>
                )}
              </button>
            </div>
            <button className="close-button" data-bs-dismiss="modal" onClick={() => {
              closeModal('newChatModal');
              resetNewDocumentResearchFields();
            }} >
              <i className="feather-x"></i>
            </button>
          </div>
        </div>
      </div>

     {/* ==== Career Modal ==== */}
     <div
        id="newCareerModal"
        className="modal rbt-modal-box copy-modal fade"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content wrapper top-flashlight light-xl">
            <h5 className="title mb-4">Choose Your Career Path</h5>
            
            <nav className="juree-tab">
              <div
                className="tab-btn-grp nav nav-tabs mb-3 text-center justify-content-center"
                id="career-path-tab"
                role="tablist"
              >
                <button
                  className={`nav-link ${careerPath === 'Solicitor' ? 'active' : ''}`}
                  onClick={() => {
                    setCareerPath('Solicitor');
                    setSolicitorPath('');
                    setSelectedOption('');
                    setSearchTerm('');
                  }}
                >
                  Solicitor
                </button>
                <button
                  className={`nav-link ${careerPath === 'Barrister' ? 'active' : ''}`}
                  onClick={() => {
                    setCareerPath('Barrister');
                    setSolicitorPath('');
                    setSelectedOption('');
                    setSearchTerm('');
                  }}
                >
                  Barrister
                </button>
              </div>
            </nav>

            {careerPath === 'Solicitor' && (
              <nav className="juree-tab mt-3">
                <div
                  className="tab-btn-grp nav nav-tabs mb-3 text-center justify-content-center"
                  id="solicitor-path-tab"
                  role="tablist"
                >
                  <button
                    className={`nav-link ${solicitorPath === 'TrainingContract' ? 'active' : ''}`}
                    onClick={() => {
                      setSolicitorPath('TrainingContract');
                      setSelectedOption('');
                      setSearchTerm('');
                    }}
                  >
                    Training Contract
                  </button>
                  <button
                    className={`nav-link ${solicitorPath === 'Apprenticeship' ? 'active' : ''}`}
                    onClick={() => {
                      setSolicitorPath('Apprenticeship');
                      setSelectedOption('');
                      setSearchTerm('');
                    }}
                  >
                    Apprenticeship
                  </button>
                </div>
              </nav>
            )}

            {/* Only show the search/selector if we have a valid path selected */}
            {((careerPath === 'Solicitor' && solicitorPath) || careerPath === 'Barrister') && (
              <>
                {isLoading && <p className="mt--10">Loading options...</p>}
                {error && <p className="mt--10 text-danger">{error}</p>}

                {!isLoading && !error && options.length > 0 && (
                  <div className="custom-dropdown mt-4" ref={dropdownRef}>
                    <input 
                      type="text"
                      className="form-control"
                      placeholder="Search and select a firm..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onFocus={() => setIsDropdownOpen(true)}
                    />
                    
                    {isDropdownOpen && (
                      <div className="dropdown-menu show w-100">
                        <ul className="list-unstyled m-0">
                          {filteredOptions.map((option) => (
                            <li key={option.value}>
                              <button 
                                className={`career-dropdown-item ${selectedOption === option.value ? 'active' : ''}`}
                                onClick={() => {
                                  setSelectedOption(option.value);
                                  setSearchTerm(option.label);
                                  setIsDropdownOpen(false);
                                }}
                              >
                                {option.label}
                              </button>
                            </li>
                          ))}
                          {filteredOptions.length === 0 && (
                            <li className="px-3 py-2 text-muted">No matches found</li>
                          )}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}

            <div className="create-conversation-section mt--20">
              <button
                className="btn-default btn-small"
                onClick={() => {
                  if (selectedOption) {
                    handleCreateCareerResearchConversation();
                  } else {
                    alert('Please select a firm before creating a conversation.');
                  }
                }}
                disabled={!selectedOption || isLoading || isCreatingCareerConversation}
              >
                {isCreatingCareerConversation ? (
                  <span>Creating Conversation...</span>
                ) : (
                  <span>Create Conversation</span>
                )}
              </button>
            </div>
            <button 
              className="close-button" 
              onClick={() => closeModal('newCareerModal')}  // Add onClick handler here
            >
              <i className="feather-x"></i>
            </button>
          </div>
        </div>
      </div>

      {/* ==== New Post Section Modal ==== */}
      <div
        id="newPostModal"
        className="modal rbt-modal-box copy-modal fade"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content post-creation-modal">
            <h5 className="title mb-4">Create New Post Anonymously</h5>
            <div className="post-form-section mt--20">
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Post Title"
                value={postTitle}
                onChange={(e) => setPostTitle(e.target.value)}
              />
              <textarea
                className="form-control mb-3"
                rows="5"
                placeholder="Post Content"
                value={postContent}
                onChange={(e) => setPostContent(e.target.value)}
              ></textarea>
              <button
                className="btn-default btn-small"
                onClick={handleCreateForumPost}
                disabled={isCreatingPost}
                data-bs-dismiss="modal"
              >
                {isCreatingPost ? (
                  <span>Creating Post...</span>
                ) : (
                  <span>Create Post</span>
                )}
              </button>
            </div>
            <button className="close-button" data-bs-dismiss="modal" onClick={() => closeModal('newPostModal')} >
              <i className="feather-x"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Add Reply Modal */}
      <div
        id="addReplyModal"
        className="modal rbt-modal-box copy-modal fade"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content post-creation-modal">
            <h5 className="title mb-4">Add Reply Anonymously</h5>
            <div className="post-form-section mt--20">
              <textarea
                className="form-control mb-3"
                rows="5"
                placeholder="Reply Content"
                value={replyContent}
                onChange={(e) => setReplyContent(e.target.value)}
              ></textarea>
              <button
                className="btn-default btn-small"
                onClick={handleAddReply}
                disabled={isCreatingReply}
                data-bs-dismiss="modal"
              >
                {isCreatingReply ? (
                  <span>Adding Reply...</span>
                ) : (
                  <span>Add Reply</span>
                )}
              </button>
            </div>
            <button className="close-button" data-bs-dismiss="modal" onClick={() => closeModal('addReplyModal')} >
              <i className="feather-x"></i>
            </button>
          </div>
        </div>
      </div>

      {/* ==== Like Section Modal ==== */}
      <div
        id="likeModal"
        className="modal rbt-modal-box like-modal fade"
        tabIndex="-1"
        aria-hidden="true"
      >
        {/* ... (rest of the like modal content) ... */}
      </div>

      {/* ==== DisLike Section Modal ==== */}
      <div
        id="dislikeModal"
        className="modal rbt-modal-box dislike-modal fade"
        tabIndex="-1"
        aria-hidden="true"
      >
        {/* ... (rest of the dislike modal content) ... */}
      </div>

      {/* ==== Share Section Modal ==== */}
      <div
        id="shareModal"
        className="modal rbt-modal-box share-modal fade"
        tabIndex="-1"
        aria-hidden="true"
      >
        {/* ... (rest of the share modal content) ... */}
      </div>

      {/* ==== Not Logged In Modal ==== */}
      <div
        id="notLoggedInModal"
        className="modal rbt-modal-box copy-modal fade"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content wrapper top-flashlight light-xl">
            <h5 className="title mb-4">Login Required</h5>
            <p className="mb-4">You need to be logged in to access this feature.</p>
            <div className="d-flex justify-content-center">
              <button 
                className="btn-default btn-small me-3" 
                onClick={() => handleNavigate('notLoggedInModal', '/SignUp')}
              >
                Sign Up
              </button>
              <button 
                className="btn-default btn-small" 
                onClick={() => handleNavigate('notLoggedInModal', '/SignIn')}
              >
                Sign In
              </button>
            </div>
            <button className="close-button" data-bs-dismiss="modal" onClick={() => closeModal('notLoggedInModal')} >
              <i className="feather-x"></i>
            </button>
          </div>
        </div>
      </div>

    {/* {Not Premium Modal} */}
    <div
        id="notProModal"
        className="modal rbt-modal-box copy-modal fade"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content wrapper top-flashlight light-xl">
            <h5 className="title mb-4">Juree Pro Required</h5>
            <p className="mb-4">You need to be a Juree Pro member in to access this feature.</p>
            <div className="d-flex justify-content-center">
              <button 
                className="btn-default btn-small me-3" 
                onClick={() => handleNavigate('notProModal', '/plans-billing')}
              >
                Upgrade
              </button>
            </div>
            <button className="close-button" data-bs-dismiss="modal" onClick={() => closeModal('notProModal')} >
              <i className="feather-x"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Application Edit Modal */}
      <div
        id="editApplicationModal"
        className="modal rbt-modal-box fade"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content application-edit-modal">
            <h5 className="title mb-4">Edit Application Status</h5>
            <div className="application-form-section">
              {/* Applied Status */}
              <div className="form-group">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="hasApplied"
                    checked={editFormData.has_applied}
                    onChange={(e) => setEditFormData({
                      ...editFormData,
                      has_applied: e.target.checked
                    })}
                  />
                  <label className="form-check-label" htmlFor="hasApplied">
                    Applied
                  </label>
                </div>
                {editFormData.has_applied && (
                  <input
                    type="date" 
                    className="form-control"
                    value={editFormData.applied_date ? new Date(editFormData.applied_date).toISOString().split('T')[0] : ''}
                    onChange={(e) => setEditFormData({
                      ...editFormData,
                      applied_date: e.target.value
                    })}
                  />
                )}
              </div>

              {/* Interview Status */}
              <div className="form-group">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="hasInterview"
                    checked={editFormData.has_interview}
                    onChange={(e) => setEditFormData({
                      ...editFormData,
                      has_interview: e.target.checked
                    })}
                  />
                  <label className="form-check-label" htmlFor="hasInterview">
                    Interview Scheduled
                  </label>
                </div>
                {editFormData.has_interview && (
                  <input
                    type="date"
                    className="form-control"
                    value={editFormData.interview_date ? new Date(editFormData.interview_date).toISOString().split('T')[0] : ''}
                    onChange={(e) => setEditFormData({
                      ...editFormData,
                      interview_date: e.target.value
                    })}
                  />
                )}
              </div>

              {/* Offer Status */}
              <div className="form-group">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="hasOffer"
                    checked={editFormData.has_offer}
                    onChange={(e) => setEditFormData({
                      ...editFormData,
                      has_offer: e.target.checked
                    })}
                  />
                  <label className="form-check-label" htmlFor="hasOffer">
                    Offer Received
                  </label>
                </div>
                {editFormData.has_offer && (
                  <input
                    type="date"
                    className="form-control"
                    value={editFormData.offer_date ? new Date(editFormData.offer_date).toISOString().split('T')[0] : ''}
                    onChange={(e) => setEditFormData({
                      ...editFormData,
                      offer_date: e.target.value
                    })}
                  />
                )}
              </div>

              {/* Notes */}
              <div className="form-group">
                <label className="form-label">Notes</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={editFormData.notes}
                  onChange={(e) => setEditFormData({
                    ...editFormData,
                    notes: e.target.value
                  })}
                ></textarea>
              </div>

              <button
                className="btn-default btn-small"
                onClick={handleEditApplication}
              >
                Save Changes
              </button>
            </div>
            <button 
              className="close-button" 
              onClick={() => closeModal('editApplicationModal')}
            >
              <i className="feather-x"></i>
            </button>
          </div>
        </div>
      </div>
    </> 
  );
};

export default Modal;

